import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ModalStyle.css";
import middleware from "../Api/Middleware";
import { ButtonBlue, ButtonLightGrey } from '../HouseStyle/Components/Buttons';

const ConfirmationModal = ({
  showConfirmation,
  setShowConfirmation,
  acceptationFunction,
  message = "Weet u zeker dat u deze actie wilt uitvoeren?",
  cancelButtonText = "Annuleren",
  acceptButtonText = "Bevestigen",
}) => {
  
  return (
      <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)} centered size="xl">
        <Modal.Header className="modalTop d-flex justify-content-between">
          <Modal.Title className="ms-3 BlockTitle ">Let op!</Modal.Title>
          <button
            className="border-0 bg-transparent"
            variant="transparent"
            onClick={() => setShowConfirmation(false)}
          >
            <FontAwesomeIcon icon={faXmark} className="closeModal" />
          </button>
        </Modal.Header>
        <Modal.Body className="modalCenter pb-0 justify-content-around">
          <div className="ms-3">
            {message}
          </div>
        </Modal.Body>
        <Modal.Footer className="modalBottom">
          <div className="d-flex flex-row">
            <div className="me-3">
              <ButtonLightGrey text={cancelButtonText} className="ms-3 btn bg-danger text-white" onClickFunction={() => setShowConfirmation(false)}/>
            </div>
            <ButtonBlue
              text={acceptButtonText}
              onClickFunction={() => {
                acceptationFunction();
                setShowConfirmation(false);
              }}
            />
            </div>
        </Modal.Footer>
      </Modal>
  );
}

export default ConfirmationModal;
